import type { CapabilitiesSnapshot } from '../../entities/me/me-contract.types';

/**
 * Показ сценариев «дом платформы» вне сайдбара (селектор организации, «без контекста»): только `staff_admin_shell.allowed`.
 * Отдельного пункта «Платформа» в левом меню нет — список организаций в каталоге (`/platform-organizations` → `/superadmin/organizations`).
 */
export function canShowPlatformShellHome(capabilities: CapabilitiesSnapshot | null | undefined): boolean {
  return Boolean(capabilities?.staff_admin_shell?.allowed);
}
